import React, { Component } from 'react';
import { Modal, Button, Spin, message, Checkbox, Table } from 'antd';
import { EventBelongType } from './Widget';
import FormList from '../../basicElement/FormList';
import DeleteContent from '../../basicElement/DeleteContent'
import TopInfo from '../../basicElement/TopInfo';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';
import moment from 'moment';

const dateFormat = 'YYYY-MM-DD';

class Update extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            hasEdit: false,
            loading: false,
            investigation: {},
            piModalVisible: false,
            piOptions: [],
            piAddClickCount: 0,
        };
    }

    componentDidMount() {
        this.restData();
        this.queryInvestigation();
    }

    restData = () => {
        const { status } = this.props;
        if (status !== 'add') {
            this.loadData();
        } else {
            const { siteId, userId, userName, investigationSiteName } = sessionStorage;
            const isSingleSite = siteId > 0;
            const data = {
                reportUserId: userId,
                reportUserName: userName,
            };

            if (isSingleSite) {
                data.influenceLevel = 'SITE_LEVEL';
                data.majorSiteList = [{ investigationSiteId: Number(siteId), investigationSiteName }]
            }
            data.reportTypeIds = [];
            data.majorSitePiList = [];
            data.eventDiscoveryProcess = '';
            data.isRelatedToCrc = undefined;
            data.relatedToCrcRemark = '';
            data.rootCauseAnalysis = '';
            data.capaPlan = '';
            data.finalTreatmentImpactId = [];
            data.finalTreatmentImpact = '';
            data.sponsorPmContactInfo = '';
            data.croPmContactInfo = '';
            data.researchProtocolName = '';
            this.setState({ data });
        }
    }

    loadData = () => {
        const { data: { majorEventId } } = this.props;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.execute.getMajorEventDetail,
            data: { majorEventId },
            dataType: 'json',
            doneResult: res => {
                const { data } = res;
                const { majorEventTypeList, majorMainResponsibleList, majorPossibleImpactList, majorSitePiList, ...rest } = data;
                if (majorEventTypeList) {
                    majorEventTypeList.forEach(i => {
                        const { firstTypeId, secondTypeId, firstTypeValue, secondTypeValue } = i;
                        i.optionValue = firstTypeValue;
                        i.childOptionValue = secondTypeValue;
                        i.majorConfigureId = firstTypeId;
                        i.childMajorConfigureId = secondTypeId;
                    });
                }
                let majorPossibleImpactRemark = '';
                const newMajorPossibleImpactList = (majorPossibleImpactList || []).map(i => {
                    if (!majorPossibleImpactRemark) {
                        majorPossibleImpactRemark = i.remark;
                    }
                    return i.possibleImpactId;
                });
                const reportTypeIds = rest.reportTypeIds ? rest.reportTypeIds.split(',').map(i => Number(i)) : [];
                const finalTreatmentImpactIdArr = rest.finalTreatmentImpactIds ? String(rest.finalTreatmentImpactIds).split(',').map(i => Number(i)).filter(i => !isNaN(i)) : [];
                this.setState({
                    hasEdit: false,
                    loading: false,
                    data: {
                        ...rest,
                        reportTypeIds,
                        majorEventTypeList: majorEventTypeList || [],
                        majorPossibleImpactRemark,
                        majorPossibleImpactList: newMajorPossibleImpactList,
                        majorSitePiList: majorSitePiList || [],
                        finalTreatmentImpactId: finalTreatmentImpactIdArr,
                        eventDiscoveryProcess: rest.eventDiscoveryProcess || '',
                        isRelatedToCrc: rest.isRelatedToCrc != null ? String(rest.isRelatedToCrc) : undefined,
                        relatedToCrcRemark: rest.relatedToCrcRemark || '',
                        rootCauseAnalysis: rest.rootCauseAnalysis || '',
                        capaPlan: rest.capaPlan || '',
                        sponsorPmContactInfo: rest.sponsorPmContactInfo || '',
                        croPmContactInfo: rest.croPmContactInfo || '',
                        researchProtocolName: rest.researchProtocolName || '',
                        finalTreatmentImpact: rest.finalTreatmentImpact || '',
                    },
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    queryInvestigation = () => {
        const { data: { investigationId } } = this.props;
        const { invId } = sessionStorage;
        const options = {
            method: 'POST',
            url: API_URL.investigation.view,
            data: { investigationId: investigationId || invId },
            dataType: 'json',
            doneResult: res => {
                const { data: { investigation } } = res;
                this.setState({ investigation });
            }
        };
        $.sendRequest(options);
    }

    handleChange = (value, key, type) => {
        const { data } = this.state;
        if (type === 'searchRetrieve') {
            data[key] = value.text;
            if (key === 'reportUserName') {
                data['reportUserId'] = value.value;
            }
        } else if (type === 'searchRetrieveBtn') {
            const { data: record } = this.props;
            const { patientUserId } = record;
            data[key] = (data[key] || []).concat(value);
            if (patientUserId && key === 'majorSiteList') {
                data.reportUserName = '';
                data.reportUserId = '';
            }
            this.setState({
                data,
                hasEdit: true,
            }, () => {
                // 涉及研究中心 和 CRC 都已选择 且 piAddClickCount === 0 时，自动查询PI
                const { data: updatedData, piAddClickCount } = this.state;
                const siteList = updatedData['majorSiteList'] || [];
                const crcList = updatedData['majorCrcList'] || [];
                if (siteList.length > 0 && crcList.length > 0 && piAddClickCount === 0) {
                    this.handleQueryAddPi();
                }
            });
            return;
        } else if (key === 'influenceLevel') {
            data[key] = value;
            data.majorSiteList = [];
            data.majorCrcList = [];
            data.majorSitePiList = [];
        } else if (key === 'majorEventTypeList') {
            data[key] = value;
        } else if (key === 'majorPossibleImpactList') {
            const possibleImpact = this.getOptions(this.props.config['POSSIBLE_IMPACT']);
            const otherPossibleImpactId = (possibleImpact.find(i => i.label === '其他影响') || {})['value'];
            const majorPossibleImpactRemarkDisplay = (value || []).includes(otherPossibleImpactId);
            if (!majorPossibleImpactRemarkDisplay) {
                data.majorPossibleImpactRemark = '';
            }
            data[key] = value;
        } else if (key === 'finalTreatmentImpactId') {
            data[key] = value;
            const finalImpactConfig = this.props.config['FINAL_TREATMENT_IMPACT'] || [];
            const otherItem = finalImpactConfig.find(i => i.attribute === 'other');
            const otherFinalImpactId = otherItem ? otherItem.majorConfigureId : undefined;
            if (!otherFinalImpactId || !(value || []).includes(otherFinalImpactId)) {
                data.finalTreatmentImpact = '';
            }
        } else if (key === 'isRelatedToCrc') {
            data[key] = value;
            if (value !== '0') {
                data.relatedToCrcRemark = '';
            }
        } else if (key === 'eventReportDate') {
            data[key] = value;
            const { status } = this.props;
            if (status === 'add') {
                data.reportToPmLmDate = value;
                data.reportToQaDate = value;
            }
        } else {
            data[key] = value;
        }
        this.setState({
            data,
            hasEdit: true,
        });
    }

    getContent = (key) => {
        const { data } = this.state;
        const list = data[key] || [];
        const result = [];
        if (key === 'majorEventTypeList') {
            list.forEach((item, index) => {
                const { optionValue, childOptionValue, childMajorConfigureId } = item;
                const content = `${optionValue}：${childOptionValue}`;
                result.push(
                    <div key={childMajorConfigureId}>
                        <DeleteContent
                            className="select-item"
                            onClick={() => this.handleDelete(index, key)}
                            children={<span title={content} >{content}</span>}
                        />
                    </div>
                );
            });
        } else if (key === 'majorSiteList') {
            const { status } = this.props;
            const canDelete = !(status === 'edit' && list.length <= 1);
            list.forEach((item, index) => {
                const { investigationSiteId, investigationSiteName } = item;
                const content = investigationSiteName;
                result.push(
                    canDelete ? (
                        <DeleteContent
                            key={investigationSiteId}
                            className="select-item"
                            onClick={() => this.handleDelete(index, key)}
                            children={<span title={content} >{content}</span>}
                        />
                    ) : (
                        <div key={investigationSiteId} className="select-item" style={{ wordBreak: 'break-word' }}>
                            <span title={content}>{content}</span>
                        </div>
                    )
                );
            });
        } else if (key === 'majorCrcList') {
            list.forEach((item, index) => {
                const { userId, userCompellation, employeeCode } = item;
                const content = `${userCompellation}[${employeeCode}]`;
                result.push(
                    <DeleteContent
                        key={userId}
                        className="select-item"
                        onClick={() => this.handleDelete(index, key)}
                        children={<span title={content} >{content}</span>}
                    />
                );
            });
        } else if (key === 'majorSitePiList') {
            list.forEach((item, index) => {
                const { piUserId, piName, investigationSiteName } = item;
                const content = `${piName}（${investigationSiteName || ''}）`;
                result.push(
                    <DeleteContent
                        key={piUserId + '_' + (item.investigationSiteId || '')}
                        className="select-item"
                        onClick={() => this.handleDelete(index, key)}
                        children={<span title={content} >{content}</span>}
                    />
                );
            });
        }
        return (
            <div className="select-list">
                { result }
            </div>
        );
    }

    getOptions = (list) => {
        return (list || []).map(i => ({ label: i.optionValue, value: i.majorConfigureId }));
    }

    disabledDate = (current) => {
        const { maxDate } = this.props;
        const value = moment(moment(maxDate).format(dateFormat)).add(1, 'd').valueOf();
        return current && current.valueOf() >= value;
    }

    getUser = (list) => {
        const len = (list || []).length;
        const result = (list || []).map((d, i) => {
            const { userId, leaderNameCode: userName } = d;
            return (<span key={userId}>{userName}{(i < len - 1) && '；'}</span>);
        });
        return result;
    }

    getReportTypeOptions = () => {
        const { config } = this.props;
        return this.getOptions(config['REPORT_TYPE']);
    }

    getFinalTreatmentImpactOptions = () => {
        const { config } = this.props;
        return this.getOptions(config['FINAL_TREATMENT_IMPACT']);
    }

    getMajorEventCategory = (majorEventTypeList) => {
        if (!majorEventTypeList || majorEventTypeList.length === 0) return '';
        const categories = [...new Set(majorEventTypeList.map(item => item.optionValue))];
        return categories.join('；');
    }

    handleQueryAddPi = () => {
        const { data, piAddClickCount } = this.state;
        const crcList = data['majorCrcList'] || [];
        const siteList = data['majorSiteList'] || [];
        if (crcList.length === 0) {
            message.warning('请先选择CRC！');
            return;
        }
        if (siteList.length === 0) {
            message.warning('请先选择涉及研究中心！');
            return;
        }
        const userIds = crcList.map(i => i.userId).join(',');
        const siteIds = siteList.map(i => i.investigationSiteId).join(',');
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url: API_URL.execute.queryPIByUserIdsAndSiteIds,
            data: { userIds, investigationSiteIds: siteIds },
            dataType: 'json',
            doneResult: res => {
                const { list = [] } = res;
                this.setState({ loading: false });
                if (list.length === 0) {
                    message.warning('未查询到PI信息');
                } else if (list.length === 1 && piAddClickCount === 0) {
                    // 仅第一次查询且只有一条时直接添加
                    const piItem = {
                        investigationSiteId: list[0].investigationSiteId,
                        piUserId: list[0].piUserId,
                        piName: list[0].piName,
                        investigationSiteName: list[0].investigationSiteName,
                    };
                    const piList = data['majorSitePiList'] || [];
                    const exists = piList.some(i => i.piUserId === piItem.piUserId && i.investigationSiteId === piItem.investigationSiteId);
                    if (!exists) {
                        piList.push(piItem);
                        data['majorSitePiList'] = piList;
                        this.setState({ data, hasEdit: true, piAddClickCount: 1 });
                    } else {
                        message.warning('该PI已存在');
                    }
                } else {
                    // 多条或第二次点击则弹框选择，将已选中的PI标记为勾选
                    const piList = data['majorSitePiList'] || [];
                    const markedList = list.map(item => ({
                        ...item,
                        _checked: piList.some(p => p.piUserId === item.piUserId && p.investigationSiteId === item.investigationSiteId),
                    }));
                    this.setState({ piModalVisible: true, piOptions: markedList, piAddClickCount: piAddClickCount + 1 });
                }
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    handlePiModalOk = () => {
        const { piOptions } = this.state;
        const { data } = this.state;
        const selected = piOptions.filter(i => i._checked);
        if (selected.length === 0) {
            message.warning('请至少选择一个PI');
            return;
        }
        // 用弹框选中的PI替换整个列表，未选中的从列表中移除
        const newPiList = selected.map(item => ({
            investigationSiteId: item.investigationSiteId,
            piUserId: item.piUserId,
            piName: item.piName,
            investigationSiteName: item.investigationSiteName,
        }));
        data['majorSitePiList'] = newPiList;
        this.setState({ data, hasEdit: true, piModalVisible: false, piOptions: [], piAddClickCount: 0 });
    }

    handlePiModalCancel = () => {
        this.setState({ piModalVisible: false, piOptions: [], piAddClickCount: 0 });
    }

    handlePiCheckChange = (index, checked) => {
        const { piOptions } = this.state;
        piOptions[index]._checked = checked;
        this.setState({ piOptions });
    }

    handleDelete = (index, key) => {
        const { data } = this.state;
        const list = data[key] || [];

        if (key === 'majorSiteList') {
            // 获取被删除中心的ID
            const deletedSite = list[index];
            const deletedSiteId = deletedSite ? deletedSite.investigationSiteId : null;

            list.splice(index, 1);
            data[key] = list;

            // 同时删除该中心关联的CRC
            if (deletedSiteId != null) {
                const crcList = data['majorCrcList'] || [];
                data['majorCrcList'] = crcList.filter(crc => crc.investigationSiteId !== deletedSiteId);

                // 同时删除该中心关联的PI
                const piList = data['majorSitePiList'] || [];
                data['majorSitePiList'] = piList.filter(pi => pi.investigationSiteId !== deletedSiteId);
            }

            const { data: record } = this.props;
            const { patientUserId } = record;
            if (patientUserId) {
                data.reportUserName = '';
                data.reportUserId = '';
            }
        } else {
            list.splice(index, 1);
            data[key] = list;
        }

        this.setState({
            data,
            hasEdit: true,
        });
    }

    getColumns = () => {
        const { status, config, data: record } = this.props;
        const { data, investigation } = this.state;
        const { patientUserId } = record;
        const { majorCrcList, majorSiteList } = data;
        const { invId, siteId } = sessionStorage;
        const isSingleSite = siteId > 0;
        const { diseaseName, diseaseRemark, pmUserList, leaderNameCode } = investigation;

        const isBelongVoliation = !!patientUserId;
        const canEdit = status === 'add' || status === 'edit';

        const disease = diseaseRemark ? `${diseaseName}(${diseaseRemark})` : diseaseName;
        const pm = ((pmUserList || []).find(i => i.isMain === '1') || {}).userName;

        const investigationSiteIds = (majorSiteList || []).map(i => i.investigationSiteId).join(',');
        const newInvestigationSiteIds = isSingleSite ? siteId : investigationSiteIds;

        const leaderList = [];
        const selectedCrc = {};
        (majorCrcList || []).forEach((i, index) => {
            (i.leaderList || []).forEach(j => {
                const isExist = leaderList.some(i => i.leaderId === j.leaderId);
                if (!isExist) {
                    leaderList.push(j);
                }
            });
            selectedCrc[`majorCrcList[${index}].userId`] = i.userId;
            selectedCrc[`majorCrcList[${index}].investigationSiteId`] = i.investigationSiteId;
        });
        const crcLeader = leaderList.map(i => `${i.leaderName}[${i.leaderEmployeeCode}]`).join('；');

        const possibleImpact = this.getOptions(config['POSSIBLE_IMPACT']);
        const otherPossibleImpactId = (possibleImpact.find(i => i.label === '其他影响') || {})['value'];
        const majorPossibleImpactRemarkDisplay = (data['majorPossibleImpactList'] || []).includes(otherPossibleImpactId);

        const finalImpactOptions = this.getFinalTreatmentImpactOptions();
        const finalImpactConfig = config['FINAL_TREATMENT_IMPACT'] || [];
        const otherFinalImpactItem = finalImpactConfig.find(i => i.attribute === 'other');
        const otherFinalImpactId = otherFinalImpactItem ? otherFinalImpactItem.majorConfigureId : undefined;
        const finalOtherDisplay = otherFinalImpactId ? (data['finalTreatmentImpactId'] || []).includes(otherFinalImpactId) : false;

        const isShowBlind = investigation['secondLineNames'] === '非盲';
        const majorEventCategory = this.getMajorEventCategory(data['majorEventTypeList']);

        // 字段属性配置
        const columns = [{
            name: '报告时间及报告人',
            type: 'title',
            children: [{
                name: '报告类型',
                key: 'reportTypeIds',
                type: 'checkBox',
                typeProperty: {
                    list: this.getReportTypeOptions(),
                },
                rules: {
                    required: true,
                }
            }, {
                name: '事件发生时间',
                key: 'eventHappenDate',
                type: 'datePicker',
                typeProperty: {
                    style: { width: 240 },
                    disabledDate: this.disabledDate,
                },
                rules: {
                    required: true,
                }
            }, {
                name: '事件获知时间',
                key: 'eventKnowDate',
                type: 'datePicker',
                typeProperty: {
                    style: { width: 240 },
                    disabledDate: this.disabledDate,
                },
                rules: {
                    required: true,
                }
            }, {
                name: '事件报告时间',
                key: 'eventReportDate',
                type: 'datePicker',
                typeProperty: {
                    style: { width: 240 },
                    disabledDate: this.disabledDate,
                },
                rules: {
                    required: true,
                }
            },
            !(isBelongVoliation || !canEdit) ?
                {
                    name: '报告人',
                    key: 'reportUserName',
                    type: 'text',
                    typeProperty: {
                        value: data['reportUserName'],
                    },
                }
            :
                {
                    name: '报告人',
                    key: 'reportUserName',
                    type: 'searchRetrieve',
                    typeProperty:{
                        keyword: 'codeName',
                        style: { width: 240 },
                        placeholder: '输入姓名或工号检索',
                        params: {limit: 20, investigationId: invId, investigationSiteIds },
                        url: API_URL.execute.queryInvPmCRC,
                        config: { id: 'userId', name: 'userCompellation' },
                    },
                    rules:{
                        required: true,
                    }
                }
            ,{
                name: '上报PM/LM时间',
                key: 'reportToPmLmDate',
                type: 'datePicker',
                typeProperty: {
                    style: { width: 240 },
                    disabledDate: this.disabledDate,
                },
                rules: {
                    required: true,
                }
            }, {
                name: '上报QA时间',
                key: 'reportToQaDate',
                type: 'datePicker',
                typeProperty: {
                    style: { width: 240 },
                    disabledDate: this.disabledDate,
                },
                rules: {
                    required: true,
                }
            }]
        }, {
            name: '项目基本信息及事件风险',
            type: 'title',
            children: [{
                name: '项目简称',
                key: 'investigationName',
                type: 'text',
                typeProperty: {
                    value: investigation['investigationName'],
                },
            }, {
                name: '研究产品名称',
                key: 'investigationSpecialName',
                type: 'text',
                typeProperty: {
                    value: investigation['investigationSpecialName'],
                },
            }, {
                name: '研究方案名称',
                key: 'researchProtocolName',
                type: 'input',
                typeProperty: {
                    style: { width: 240 },
                },
            }, {
                name: '方案编号',
                key: 'investigationCode',
                type: 'text',
                typeProperty: {
                    value: investigation['investigationCode'],
                },
            }, {
                name: '业务线',
                key: 'lineOfBusinessString',
                type: 'text',
                typeProperty: {
                    value: investigation['lineOfBusinessString'],
                },
            }, {
                name: '执行业务线二级分类',
                key: 'secondLineNames',
                type: 'text',
                typeProperty: {
                    value: investigation['secondLineNames'],
                },
            }, {
                name: '配套盲态项目信息',
                key: 'blindInvestigationName',
                type: 'text',
                typeProperty: {
                    value: investigation['blindInvestigationName'],
                },
                rules: {
                    display: isShowBlind,
                },
            }, {
                name: '项目领域',
                key: 'investigationAreaName',
                type: 'text',
                typeProperty: {
                    value: investigation['investigationAreaName'],
                },
            }, {
                name: '疾病',
                key: 'diseaseName',
                type: 'text',
                typeProperty: {
                    value: disease,
                },
            }, {
                name: '领域leader',
                key: 'fieldLeader',
                type: 'text',
                typeProperty: {
                    value: this.getUser(leaderNameCode),
                },
            }, {
                name: '研究产品类型',
                key: 'investigationMedicineName',
                type: 'text',
                typeProperty: {
                    value: investigation['investigationMedicineName'],
                },
            }, {
                name: '给药方式',
                key: 'administrationModeShow',
                type: 'text',
                typeProperty: {
                    value: investigation['administrationModeShow'],
                },
                rules: {
                    display: investigation['investigationMedicineType'] === 'Research_drugs',
                },
            }, {
                name: '申办方',
                key: 'investigationSponsor',
                type: 'text',
                typeProperty: {
                    value: investigation['investigationSponsor'],
                },
            }, {
                name: 'CRO',
                key: 'cro',
                type: 'text',
                typeProperty: {
                    value: investigation['cro'],
                },
            }, {
                name: '津石PM',
                key: 'pm',
                type: 'text',
                typeProperty: {
                    value: pm,
                },
            }, {
                name: '申办方PM',
                key: 'sponsorPm',
                type: 'input',
                typeProperty: {
                    style: { width: 240 },
                },
            }, {
                name: '联系方式',
                key: 'sponsorPmContactInfo',
                type: 'input',
                typeProperty: {
                    style: { width: 240 },
                },
            }, {
                name: 'CRO PM',
                key: 'croPm',
                type: 'input',
                typeProperty: {
                    style: { width: 240 },
                },
            }, {
                name: '联系方式',
                key: 'croPmContactInfo',
                type: 'input',
                typeProperty: {
                    style: { width: 240 },
                },
            }, {
                name: '涉及层面',
                key: 'influenceLevel',
                type: 'radio',
                typeProperty: {
                    list: [{ label: '项目层面', value: 'INVESTIGATION_LEVEL' }, { label: '中心层面', value: 'SITE_LEVEL' }],
                    style: { width: 240 },
                    disabled: isSingleSite || status === 'edit',
                },
                rules: {
                    required: true,
                }
            }, {
                name: '涉及研究中心',
                key: 'majorSiteList',
                type: 'searchRetrieveBtn',
                typeProperty: {
                    keyword: 'investigationSiteNameCode',
                    style: { width: 240 },
                    placeholder: '输入中心编号/名称检索',
                    params: {limit: 20, investigationId: invId, investigationSiteIds },
                    url: API_URL.investigation.queryInvestigationSiteList,
                    config: { id: 'investigationSiteId', name: 'investigationSiteName', type: 'investigationSite' },
                    content: this.getContent('majorSiteList'),
                    disabled: status === 'edit' && (data['majorSiteList'] || []).length <= 1,
                },
                rules: {
                    required: true,
                    display: data['influenceLevel'] === 'SITE_LEVEL',
                },
            }, {
                name: 'CRC',
                key: 'majorCrcList',
                type: 'searchRetrieveBtn',
                typeProperty: {
                    keyword: 'nameCode',
                    style: { width: 240 },
                    placeholder: '输入姓名/工号检索',
                    disabled: !newInvestigationSiteIds,
                    params: {limit: 20, investigationSiteIds: newInvestigationSiteIds, ...selectedCrc},
                    url: API_URL.execute.queryCrcBySiteIds,
                    config: { id: 'userId', name: 'userCompellation', code: 'employeeCode', show: 'user' },
                    content: this.getContent('majorCrcList'),
                },
                rules: {
                    required: true,
                    display: data['influenceLevel'] === 'SITE_LEVEL',
                },
            }, {
                name: 'CRC直线主管',
                key: 'crcLeader',
                type: 'text',
                typeProperty: {
                    value: crcLeader,
                },
                rules: {
                    display: data['influenceLevel'] === 'SITE_LEVEL',
                },
            }, {
                name: 'PI',
                key: 'majorSitePiList',
                type: 'custom',
                typeProperty: {
                    content: (
                        <div>
                            <div className="select-list">
                                {this.getContent('majorSitePiList')}
                            </div>
                            {
                                canEdit && data['influenceLevel'] === 'SITE_LEVEL' &&
                                <Button type="ghost" style={{ marginBottom: 10 }} onClick={this.handleQueryAddPi}>添加PI</Button>
                            }
                        </div>
                    ),
                },
                rules: {
                    display: data['influenceLevel'] === 'SITE_LEVEL',
                },
            }, {
                name: '重大事件/潜在重大事件分类',
                key: 'majorEventCategory',
                type: 'text',
                typeProperty: {
                    value: majorEventCategory,
                },
            }, {
                name: '事件归属类型',
                key: 'majorEventTypeList',
                type: 'selectModal',
                typeProperty: {
                    style: { width: 240 },
                    SelectModal: EventBelongType,
                    modalProps: {
                        list: config['EVENT_TYPE'],
                    },
                    content: this.getContent('majorEventTypeList'),
                },
                rules: {
                    required: true,
                },
            }, {
                name: '重大事件/潜在重大事件可能造成的影响（可多选）',
                key: 'majorPossibleImpactList',
                type: 'checkBox',
                typeProperty: {
                    list: possibleImpact,
                },
                rules: {
                    required: true,
                }
            }, {
                name: <span>&nbsp;</span>,
                key: 'majorPossibleImpactRemark',
                type: 'input',
                typeProperty: {
                    style: { width: 240 },
                },
                rules: {
                    colon: false,
                    required: true,
                    display: canEdit && majorPossibleImpactRemarkDisplay,
                    msg: '请填写重大事件可能造成的影响补充说明',
                },
            }]
        }, {
            name: <div>详述发现和处理重大问题/潜在重大问题的过程或总结<span style={{color: 'orange'}}>(涉及的人物、时间文件及执行动作请完整描述)</span></div>,
            type: 'title',
            children: [{
                name: '项目或方案要求描述',
                key: 'projectSchemeDescription',
                type: 'input',
                typeProperty: {
                    style: { width: 240 },
                },
                rules: {
                    required: true,
                }
            }, {
                name: '实际操作情况',
                key: 'actualOperation',
                type: 'input',
                typeProperty: {
                    style: { width: 240 },
                },
                rules: {
                    required: true,
                }
            }, {
                name: '事件发现过程',
                key: 'eventDiscoveryProcess',
                type: 'input',
                typeProperty: {
                    style: { width: 240 },
                },
                rules: {
                    required: true,
                }
            }, {
                name: '目前对受试者及研究中心的影响',
                key: 'impactToSubjectsSite',
                type: 'input',
                typeProperty: {
                    style: { width: 240 },
                },
                rules: {
                    required: true,
                }
            }, {
                name: '是否与CRC工作相关',
                key: 'isRelatedToCrc',
                type: 'radio',
                typeProperty: {
                    list: [{ label: '是', value: '1' }, { label: '否', value: '0' }],
                },
                rules: {
                    required: true,
                }
            }, {
                name: <span>&nbsp;</span>,
                key: 'relatedToCrcRemark',
                type: 'input',
                typeProperty: {
                    style: { width: 240 },
                },
                rules: {
                    colon: false,
                    required: true,
                    display: canEdit && data['isRelatedToCrc'] === '0',
                    msg: '请填写备注信息',
                },
            }, {
                name: '根本原因调查、分析和确认(包括列举事件的直接原因、调查过程、可能的潜在原因及根本原因)',
                key: 'rootCauseAnalysis',
                type: 'input',
                typeProperty: {
                    style: { width: 240 },
                },
            }, {
                name: 'CAPA计划及责任人',
                key: 'capaPlan',
                type: 'input',
                typeProperty: {
                    style: { width: 240 },
                },
            }, {
                name: '已采取的措施或计划',
                key: 'majorMeasurePlanList',
                type: 'table',
                typeProperty: {
                    list: [{
                        name: '措施/计划',
                        key: 'measurePlan',
                        type: 'input',
                        rules: {
                            required: true,
                        }
                    }, {
                        name: '计划完成时间',
                        key: 'planCompletionTimeStr',
                        type: 'datePicker',
                        typeProperty: {
                            style: { width: 120 },
                        },
                        rules: {
                            required: true,
                        }
                    }, {
                        name: '责任人',
                        key: 'liableUser',
                        type: 'input',
                        typeProperty: {
                            style: { width: 120 },
                        },
                        rules: {
                            required: true,
                        }
                    }, {
                        name: '实际完成时间',
                        key: 'actualCompletionTimeStr',
                        type: 'datePicker',
                        typeProperty: {
                            style: { width: 120 },
                            disabledDate: this.disabledDate,
                        },
                    }],
                    scrollY: 240,
                },
                rules: {
                    required: true,
                }
            }, {
                name: '重大事件处理结束与否',
                key: 'majorDealIsEnd',
                type: 'radio',
                typeProperty: {
                    list: [
                        { label: '是', value: '1' },
                        { label: '否', value: '0' },
                    ],
                },
                rules: {
                    required: true,
                }
            }, {
                name: '最终处理情况及影响（总结报告时更新此处，可多选）',
                key: 'finalTreatmentImpactId',
                type: 'checkBox',
                typeProperty: {
                    list: finalImpactOptions,
                },
            }, {
                name: <span>&nbsp;</span>,
                key: 'finalTreatmentImpact',
                type: 'input',
                typeProperty: {
                    style: { width: 240 },
                },
                rules: {
                    colon: false,
                    required: true,
                    display: canEdit && finalOtherDisplay,
                    msg: '请填写其他说明',
                },
            }, {
                name: '备注',
                key: 'comments',
                type: 'input',
                typeProperty: {
                    style: { width: 240 },
                },
            }]
        }];

        // 字段值、显示状态配置
        const traverseColumns = function (columns) {
            columns.forEach(column => {
                const { key, type, children, rules = {} } = column;
                if (children) {
                    traverseColumns(children);
                } else {
                    const typeProperty = column.typeProperty || (column.typeProperty = {});
                    typeProperty.canEdit = canEdit;
                    if (!canEdit) {
                        if (type === 'radio') {
                            const list = typeProperty.list;
                            const value = data[key];
                            const label = ((list || []).find(i => i.value == value)|| {})['label'];
                            typeProperty.value = label || '';
                        } else if (type === 'checkBox') {
                            const list = typeProperty.list;
                            const value = data[key] || [];
                            const labelList = (list || []).filter(i => value.includes(i.value)).map(i => i.label);
                            let newLabelList
                            if (key === 'majorPossibleImpactList') {
                                newLabelList = labelList.map(i => {
                                    if (i === '其他影响') {
                                        return i += `(${data['majorPossibleImpactRemark']})`;
                                    } else {
                                        return i;
                                    }
                                });
                            } else if (key === 'finalTreatmentImpactId') {
                                newLabelList = labelList.map(i => {
                                    if (i === '其他' && data['finalTreatmentImpact']) {
                                        return i += `(${data['finalTreatmentImpact']})`;
                                    } else {
                                        return i;
                                    }
                                });
                            }
                            typeProperty.value = (newLabelList || labelList).join('；');
                        } else if (type === 'searchRetrieveBtn') {
                            const value = data[key];
                            if (key === 'majorSiteList') {
                                typeProperty.value = (value || []).map(i => i.investigationSiteName).join('；');
                            } else if (key === 'majorCrcList') {
                                typeProperty.value = (value || []).map(i => `${i.userCompellation}[${i.employeeCode}]`).join('；');
                            }
                        } else if (type === 'selectModal') {
                            const value = data[key];
                            typeProperty.value = (value || []).map(i => <div key={i.childMajorConfigureId}>{i.optionValue}：{i.childOptionValue}</div>);
                        } else if (type === 'datePicker') {
                            const value = data[key];
                            typeProperty.value = value ? value.slice(0, 10) : '';
                        } else if (type === 'custom') {
                            const value = data[key];
                            if (key === 'majorSitePiList') {
                                typeProperty.value = (value || []).map(i => `${i.piName}（${i.investigationSiteName || ''}）`).join('；');
                            }
                        } else if (type !== 'text') {
                            typeProperty.value = data[key];
                        }
                        if (rules.hasOwnProperty('required')) {
                            rules.required = false;
                        }
                    } else {
                        if (type !== 'text' && type !== 'custom') {
                            typeProperty.value = data[key];
                        }
                    }
                }
            });
        }
        traverseColumns(columns);

        return columns;
    }

    handleClick = () => {
        const { status } = this.props;
        const { hasEdit } = this.state;
        if (status === 'edit' && hasEdit) {
            Modal.confirm({
                iconType: 'question-circle',
                title: <div style={{ marginLeft: 42 }}>是否放弃本次编辑，返回列表？</div>,
                onOk: () => this.props.onChange({}, ''),
            })
        } else {
            this.props.onChange({}, '');
        }
    }

    confirm = () => {
        const hasWritten = this.formRef.validate();
        if (!hasWritten) return;

        const { data } = this.state;

        // 中心层面且已有CRC和中心时，校验每个中心必须至少有一个PI
        if (data['influenceLevel'] === 'SITE_LEVEL') {
            const crcList = data['majorCrcList'] || [];
            const siteList = data['majorSiteList'] || [];
            const piList = data['majorSitePiList'] || [];
            if (crcList.length > 0 && siteList.length > 0) {
                const siteWithoutPi = siteList.filter(site =>
                    !piList.some(pi => pi.investigationSiteId === site.investigationSiteId)
                );
                if (siteWithoutPi.length > 0) {
                    const names = siteWithoutPi.map(s => s.investigationSiteName).join('、');
                    message.warning(`中心【${names}】未配置PI，请先添加PI`);
                    return;
                }
            }
        }
        const params = {};
        for (let [key, value] of Object.entries(data)) {
            const valueType = typeof value;
            if (valueType !== 'object') {
                if (valueType === 'string' && value.endsWith('00:00:00')) {
                    params[key] = value.slice(0, 10);
                } else {
                    params[key] = value;
                }
            }
            if (key === 'majorCrcList') {
                value.forEach((i, index) => {
                    params[`majorCrcList[${index}].userId`] = i.userId;
                    params[`majorCrcList[${index}].investigationSiteId`] = i.investigationSiteId;
                });
            } else if (key === 'majorSiteList') {
                value.forEach((i, index) => {
                    params[`majorSiteList[${index}].investigationSiteId`] = i.investigationSiteId;
                });
            } else if (key === 'majorEventTypeList') {
                value.forEach((i, index) => {
                    params[`majorEventTypeList[${index}].firstTypeId`] = i.majorConfigureId;
                    params[`majorEventTypeList[${index}].secondTypeId`] = i.childMajorConfigureId;
                });
            } else if (key === 'majorMainResponsibleList') {
                value.forEach((i, index) => {
                    params[`majorMainResponsibleList[${index}].mainResponsibleId`] = i;
                });
            } else if (key === 'majorPossibleImpactList') {
                value.forEach((i, index) => {
                    params[`majorPossibleImpactList[${index}].possibleImpactId`] = i;
                    params[`majorPossibleImpactList[${index}].remark`] = data['majorPossibleImpactRemark'];
                });
            } else if (key === 'majorSitePiList') {
                value.forEach((i, index) => {
                    params[`majorSitePiList[${index}].investigationSiteId`] = i.investigationSiteId;
                    params[`majorSitePiList[${index}].piUserId`] = i.piUserId;
                });
            } else if (key === 'majorMeasurePlanList') {
                value.forEach((i, index) => {
                    params[`majorMeasurePlanList[${index}].measurePlan`] = i.measurePlan;
                    params[`majorMeasurePlanList[${index}].planCompletionTimeStr`] = i.planCompletionTimeStr;
                    params[`majorMeasurePlanList[${index}].actualCompletionTimeStr`] = i.actualCompletionTimeStr;
                    params[`majorMeasurePlanList[${index}].liableUser`] = i.liableUser;
                });
            } else if (key === 'reportTypeIds') {
                params.reportTypeIds = value.join(',');
            } else if (key === 'finalTreatmentImpactId') {
                params['finalTreatmentImpactIds'] = value.join(',');
            }
        }

        this.setState({ loading: true });
        const { status } = this.props;
        const url = status === 'add'
            ? API_URL.execute.saveMajorEvent
            : API_URL.execute.editMajorEvent;
        const options = {
            method: 'POST',
            url: url,
            data: params,
            dataType: 'json',
            doneResult: res => {
                const { success } = res;
                message.success(success);
                this.setState({
                    hasEdit: false,
                    loading: false,
                }, () => {
                    this.handleClick();
                });
            },
            errorResult: () => {
                this.setState({ loading: false });
            }
        };
        $.sendRequest(options);
    }

    render() {
        const { status, data: { majorEventNumber } } = this.props;
        const { loading, piModalVisible, piOptions } = this.state;
        const title = (status === 'add' && '添加重大事件') || (status === 'edit' && `编辑重大事件-${majorEventNumber}`) || (status === 'view' && `查看重大事件-${majorEventNumber}`);
        // documentElement.clientHeight 为真实可视区高度（随系统缩放/窗口大小变化）；
        // 查看态无底部按钮，预留 220；新增/编辑态有按钮行，预留 300；保底 320 避免小窗口时区域过小
        const height = Math.max(document.documentElement.clientHeight - (status === 'view' ? 220 : 300), 320);

        const piColumns = [{
            title: '中心名称',
            dataIndex: 'investigationSiteName',
            key: 'investigationSiteName',
        }, {
            title: 'PI姓名',
            dataIndex: 'piName',
            key: 'piName',
        }, {
            title: '选择',
            key: 'checkbox',
            width: 80,
            render: (text, record, index) => (
                <Checkbox checked={record._checked} onChange={e => this.handlePiCheckChange(index, e.target.checked)} />
            ),
        }];

        return (
            <div className="main" style={{ padding: 10 }}>
                <Spin spinning={loading}>
                    <TopInfo title={title} onClick={this.handleClick} />
                    <div style={{ overflowY: 'auto', maxHeight: height, marginTop: 12, background: '#f9f9f9' }}>
                        <FormList
                            className="form-list"
                            columns={this.getColumns()}
                            onChange={this.handleChange}
                            ref={el => this.formRef = el}
                        />
                    </div>
                    {
                        (status === 'add' || status === 'edit') &&
                        <div style={{ margin: '20px 0', textAlign: 'center' }}>
                            <Button type="ghost" onClick={() => this.restData()}>取消</Button>
                            <Button type="primary" style={{marginLeft: 10}} onClick={this.confirm}>确定</Button>
                        </div>
                    }
                </Spin>
                <Modal
                    title="添加PI"
                    visible={piModalVisible}
                    onOk={this.handlePiModalOk}
                    onCancel={this.handlePiModalCancel}
                    maskClosable={false}
                >
                    <Table
                        rowKey={(record, index) => index}
                        dataSource={piOptions}
                        columns={piColumns}
                        pagination={false}
                        size="small"
                    />
                </Modal>
            </div>
        );
    }
}

export default Update;


// WEBPACK FOOTER //
// ./src/components/execute/importantEvent/Update.js